<template>
    <modal name="edit-job-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out"
           :width="800"
           :height="760">
        <h4 class="text-center panel-heading">Details voor {{job.dutchTitle}}</h4>
        <form @submit.prevent="editJob()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse naam*</label>
                        <input type="text"
                               class="form-control"
                               v-model="job.dutchTitle"
                               required>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse naam</label>
                        <input type="text"
                               v-model="job.frenchTitle"
                               class="form-control">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="job.dutchDescription"></textarea>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="job.frenchDescription"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-4">
                        <button type="submit" class="btn btn-danger">Opslaan</button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'

    export default {
        name: 'EditJob',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL
            }
        },
        methods: {
            editJob() {
                this.$store.commit(types.SET_JOB_TO_UPDATE, this.job)
                this.$store.dispatch('editJob').then(() => {
                    if (this.isJobUpdated) {
                        this.job.dutchTitle = ''
                        this.job.frenchTitle = ''
                        this.job.dutchDescription = ''
                        this.job.frenchDescription = ''

                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Vacature is aangepast!' })
                        this.$modal.hide('edit-job-modal')
                    }
                })
            },
            beforeOpen(event) {
                if (event.params.jobId) {
                    this.$store.dispatch('getJob', event.params.jobId)
                }
            }
        },
        computed: {
            ...mapGetters({
                isJobUpdated: 'isJobUpdated',
                job: 'job',
            })
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }
</style>
